<span
  class="av-avatar av-avatar--{{ size() }} d-inline-flex align-items-center justify-content-center"
>
  @if (showImage()) {
    <img class="av-avatar__image" [src]="photoUrl()" [alt]="name()" (error)="onImageError()" />
  } @else if (initials()) {
    <span class="av-avatar__initials" [attr.aria-label]="name()">{{ initials() }}</span>
  } @else {
    <mat-icon class="av-avatar__icon" aria-hidden="true">person</mat-icon>
  }
</span>
